import { EnlacesService } from 'src/app/services/enlaces.service';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseComponent } from '../base.component';
import { Location } from '@angular/common';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent extends BaseComponent implements OnInit {

  public banners$ = this.enlacesService.getBanners$();

  private redesSocialesSAAS = {
    'instagram': `https://www.instagram.com/farmaciasaas`,
    'whatsapp': `https://wa.me/message/L5KRACYDUN6AB1`,
    'telegram': `https://t.me/farmaciasaas`
  }

  private redesSocialesBotiqueria = {
    'instagram': `https://www.instagram.com/botiqueria`,
    'whatsapp': `https://wa.me/584122684378`,
    'telegram': `https://t.me/fbotiqueria`
  }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    autoWidth:true,
    dots: false,
    navSpeed: 700,
    responsive: {
      0: {
        items: 1,
      },
    },
    nav: false,
    autoplay: true,
  };

  constructor(
    private _location: Location,
    private enlacesService: EnlacesService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer) {
    super(_location);
    this.matIconRegistry.addSvgIcon(
      `whatsapp`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/iconos/whatsapp-brands.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      `instagram`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/iconos/instagram-brands.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      `telegram`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/iconos/telegram-plane-brands.svg'
      )
    );

  }

  ngOnInit(): void {
    this.enlacesService.getBannersAPI('Contactos', this.ngUnsubscribe);
  }

  public onClick(redSocial: string): void {
    if (this.modelo == 1) {
      window.open((this.redesSocialesSAAS as any)[redSocial], '_blank');
    }
    else if (this.modelo == 2) {
      window.open((this.redesSocialesBotiqueria as any)[redSocial], '_blank');
    }
  }

}
